import { IVolTab, VolSkewBaseLine } from '../types/impliedVol';

export const IVOL_UPSELL = {
  title: 'Unlock Unlimited Implied Volatility Access',
  subtitle: "With a SpotGamma Alpha subscription, you'll get:",
  items: [
    'Real-time charts incorporating all options trades',
    'Personalized watchlist and trending names',
    'Highly actionable alerts for options and equity traders',
  ],
};

export const IVOL_APPCUES = {
  [IVolTab.FixedStrikeMatrix]: '1506c18a-ddab-4b9b-9b8a-4d3057653fb1',
  [IVolTab.TermStructure]: '0df4712b-7bed-4656-88f3-1fa779d3a156',
  [IVolTab.VolSkew]: 'dd93bfb8-8298-451c-bdce-3afec2302957',
};

export const IVOL_SKEW_BASE_LINE_LABELS_MAP: Record<VolSkewBaseLine, string> = {
  [VolSkewBaseLine.AtmIV]: 'Atm IV',
  [VolSkewBaseLine.MinIV]: 'Min IV',
  [VolSkewBaseLine.MaxIV]: 'Max IV',
  [VolSkewBaseLine.MedianIV]: 'Median IV',
  [VolSkewBaseLine.AvgIV]: 'Avg IV',
  [VolSkewBaseLine.P10_IV]: 'P10 IV',
  [VolSkewBaseLine.P25_IV]: 'P25 IV',
  [VolSkewBaseLine.P75_IV]: 'P75 IV',
  [VolSkewBaseLine.P90_IV]: 'P90 IV',
};
